import React, { useState, useEffect } from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    useTheme,
    useMediaQuery,
    Tooltip,
    Typography
} from '@mui/material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CloseIcon from '@mui/icons-material/Close';
import ResumenPrecotizacion from '../components/Precotizacion/PrecotizacionWizard';

const FloatingPrecotizacionButton = () => {
    const [open, setOpen] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // Mostrar el texto "Cotiza aquí" cada 20 segundos por 5 segundos
    useEffect(() => {
        const interval = setInterval(() => {
            setShowTooltip(true);
            setTimeout(() => setShowTooltip(false), 10000);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <>
            {/* Botón flotante */}
            <Box
                sx={{
                    position: 'fixed',
                    top: 180,
                    right: 16,
                    zIndex: 1200,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    animation: 'vibrate 1s infinite',
                    '@keyframes vibrate': {
                        '0%': { transform: 'translateX(0)' },
                        '25%': { transform: 'translateX(-2px)' },
                        '50%': { transform: 'translateX(2px)' },
                        '75%': { transform: 'translateX(-2px)' },
                        '100%': { transform: 'translateX(0)' },
                    }
                }}
            >
                {showTooltip && (
                    <Typography
                        variant="caption"
                        sx={{
                            backgroundColor: '#EBC848',
                            color: '#313131',
                            fontWeight: 600,
                            px: 1.5,
                            py: 0.5,
                            mb: 1,
                            borderRadius: 1,
                            boxShadow: '0 0 8px #EBC848',
                            fontFamily: 'Montserrat, sans-serif'
                        }}
                    >
                        Cotiza aquí
                    </Typography>
                )}

                <Tooltip title="Una cotizacion Rapida?" arrow>
                    <Button
                        variant="contained"
                        onClick={handleOpen}
                        sx={{
                            minWidth: 'auto',
                            width: '56px',
                            height: '56px',
                            borderRadius: '50%',
                            boxShadow: 3,
                            p: 0,
                            backgroundColor: '#555555',
                            '&:hover': {
                                backgroundColor: '#444444',
                                boxShadow: 4,
                                transform: 'scale(1.05)',
                                transition: 'all 0.2s ease'
                            }
                        }}
                    >
                        <ReceiptIcon fontSize="medium" />
                    </Button>
                </Tooltip>
            </Box>

            {/* Diálogo con el resumen */}
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                fullWidth
                fullScreen={isMobile}
                sx={{
                    '& .MuiDialog-paper': {
                        borderRadius: isMobile ? 0 : 2,
                        maxHeight: isMobile ? '100vh' : '90vh',
                        overflow: 'hidden'
                    }
                }}
            >
                <DialogTitle sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    backgroundColor: '#444444', // gris más oscuro
                    color: 'white',
                    py: 1,
                    px: 2
                }}>
                    <span>Una cotizacion rapida.</span>
                    <IconButton onClick={handleClose} sx={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 0, overflowY: 'auto' }}>
                    <ResumenPrecotizacion />
                </DialogContent>
            </Dialog>
        </>
    );
};

export default FloatingPrecotizacionButton;
